export const cleanUrl = (removeParams: string[]) => {
  const url = new URL(window.location.href);
  removeParams.forEach((param) => url.searchParams.delete(param));
  return url.toString();
};
